import { render, staticRenderFns } from "./phoneCode.vue?vue&type=template&id=14d34691&scoped=true&"
import script from "./phoneCode.vue?vue&type=script&lang=js&"
export * from "./phoneCode.vue?vue&type=script&lang=js&"
import style0 from "./phoneCode.vue?vue&type=style&index=0&id=14d34691&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d34691",
  null
  
)

export default component.exports